import { makeStyles } from '@material-ui/core/styles';

export const useMetaRowsSectionsStyles = makeStyles(theme => ({
  buttonContainer: {
    padding: theme.spacing(0.5, 0)
  },
  emailBody: {
    overflowX: 'auto',
    padding: theme.spacing(0, 3, 0, 1),
    '& img': {
      maxWidth: '99%'
    }
  },
  metaSection: {
    overflowX: 'hidden',
    padding: theme.spacing(0, 2)
  },
  statusChip: {
    marginLeft: theme.spacing(1)
  },
  subjectContainer: {
    padding: theme.spacing(1)
  }
}));
